export default __webpack_public_path__ + "static/media/0000ROUGE.527f80f9.pdf";